<section class="payment-container">
    <app-payment-choose-plan></app-payment-choose-plan>
</section>